<template>
  <div class="wishlist-content">
    <div class="block-widge">
      <div>
        <h1 class="mb-4">My Wishlist</h1>
      </div>
      <table v-if="dataIsLoad" class="cart-table" column="6">
        <tbody>
          <tr>
            <th>商品資訊</th>
            <th>價錢</th>
            <th>特價</th>
            <th>購物車</th>
            <th>刪除</th>
          </tr>
          <FavoriteItem
            v-for="(item, index) in data"
            :key="item.Colors[0].CustomMarketID"
            :item="item"
            :idx="index"
          />
        </tbody>
      </table>
    </div>

    <div class="cart-buttons text-center">
      <div class="row">
        <div class="offset-md-3" />
        <div class="col-12 col-md-6">
          <a class="btn btn--l text-uppercase" href="/recent">continue shopping</a>
        </div>
      </div>
    </div>

    <Pagination v-if="dataIsLoad" class="mt-5" :total-page="totalPage" />
    <CartDialog
      :dialog-data="dialogData"
      :no-arrival-notice="true"
      @change-open="changeOpen"
      @change-select="changeSelect"
    />
  </div>
</template>

<script setup>
import Pagination from '@global/components/common/pagination/PaginationLayout.vue';
import FavoriteItem from '@page/favorite/components/FavoriteItem.vue';
import CartDialog from '@components/CartDialog.vue';
import useFavorite from '@global/composable/member/useFavorite';

const { dataIsLoad, data, totalPage, fetchItems, dialogData, changeOpen, changeSelect } =
  useFavorite();

fetchItems();
</script>
